(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('DesignNameModalCtrl', designNameModalCtrl);

    function designNameModalCtrl($scope, $mdDialog, initialName) {
        $scope.name = initialName || '';

        $scope.onSubmit = function () {
            $mdDialog.hide({
                name: $scope.name,
                openProductSpecsModal: false
            });
        };
        
        $scope.createFromProductSpecs = function () {
            $mdDialog.hide({
                name: $scope.name,
                openProductSpecsModal: true
            });
        };
    }
})();
